import { WalletActionCreators } from 'actions/wallet';
import { WalletTransferState } from 'models/wallet';

export const initialState: WalletTransferState = {
  amount: 0,
  destinationPhone: '',
  error: ''
};

type Action = typeof WalletActionCreators[keyof typeof WalletActionCreators];

export function walletTransferReducer(state = { ...initialState }, action: Action): typeof initialState {
  switch (action.type) {
    case WalletActionCreators.updateTransferAmount.type:
      return { ...state, amount: action.payload };
    case WalletActionCreators.updateTransferPhone.type:
      return { ...state, destinationPhone: action.payload };
    case WalletActionCreators.updateTransferError.type:
      return { ...state, error: action.payload };
    case WalletActionCreators.clearTransfer.type:
      return { ...initialState };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/wallet/transfer.ts